import omit from "lodash/omit";
import { RestAPIClient } from "networks";
import { HTTPRequestMethods } from "networks/RestAPI/client";

import Paths from "./paths";
import * as Types from "./types";

export const company13thSettingListService = (params: {
  page?: number | null;
  limit?: number | null;
  status?: number | null;
}) =>
  RestAPIClient.call<RestAPIResponseList<Types.Company13thSetting>>({
    method: HTTPRequestMethods.GET,
    url: Paths.List,
    config: {
      requireAuthentication: true,
      params,
    },
  });

export const company13thSettingDetailService = (id: string) => {
  return RestAPIClient.call<Types.Company13thSetting>({
    method: HTTPRequestMethods.GET,
    url: Paths.Detail.replace("{id}", id),
    config: {
      requireAuthentication: true,
    },
  });
};

export const company13thSettingCreateService = (data: {
  effectiveFrom: string;
  bonusReviewDate: string;
  minimumWorkingMonth: number;
  departmentIds: number[];
  employmentStatuses: string[];
  minimumLeavesForReview: {
    code: string;
    name: string;
    value: number;
  }[];
}) =>
  RestAPIClient.call<RestAPIResponse<Types.Company13thSetting>>({
    method: HTTPRequestMethods.POST,
    url: Paths.Create,
    config: {
      requireAuthentication: true,
    },
    data,
  });

export const company13thSettingUpdateService = (
  data: Parameters<typeof company13thSettingCreateService>[0] & { id: string }
) =>
  RestAPIClient.call<RestAPIResponse<Types.Company13thSetting>>({
    method: HTTPRequestMethods.PUT,
    url: Paths.Update.replace("{id}", data.id),
    config: {
      requireAuthentication: true,
    },
    data: omit(data, "id"),
  });
